import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap'; // Import Bootstrap JS for controlling modal behavior

interface FormData {
    name: string;
    email: string;
    organization: string;
    comments: string;
}

interface FormErrors {
    name: boolean;
    email: boolean;
    emailInvalid: boolean; // Additional state to track invalid email format
    organization: boolean;
    comments: boolean;
}

const emailRegex = /^[a-zA-Z0-9._%±]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const ContactUs_ModalComponent: React.FC = () => {
    const [formData, setFormData] = useState<FormData>({
        name: '',
        email: '',
        organization: '',
        comments: ''
    });

    const [errors, setErrors] = useState<FormErrors>({
        name: false,
        email: false,
        emailInvalid: false,
        organization: false,
        comments: false
    });

    const [showThankYouModal, setShowThankYouModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('Thank You!');
    const [modalBodyText, setModalBodyText] = useState('Thank you for contacting us. We will get back to you shortly.');
    const [loading, setLoading] = useState(false);
    const [showLoading, setShowLoading] = useState(false); // State for loading spinner

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async () => {
        let validationErrors: Partial<FormErrors> = {};

        // Check if all fields are filled
        if (!formData.name.trim()) validationErrors.name = true;
        if (!formData.email.trim()) validationErrors.email = true;
        else if (!emailRegex.test(formData.email)) validationErrors.emailInvalid = true; // Validate email format
        if (!formData.organization.trim()) validationErrors.organization = true;
        if (!formData.comments.trim()) validationErrors.comments = true;

        setErrors({
            name: validationErrors.name || false,
            email: validationErrors.email || false,
            emailInvalid: validationErrors.emailInvalid || false,
            organization: validationErrors.organization || false,
            comments: validationErrors.comments || false
        });

        if (Object.keys(validationErrors).length === 0) {
            setShowLoading(true); // Show loading spinner

            // Close the staticBackdrop modal
            const modalElement = document.getElementById('staticBackdrop');
            if (modalElement) {
                const modalInstance = Modal.getInstance(modalElement); // Get the modal instance
                modalInstance?.hide(); // Close the modal

                // Manually remove the modal-backdrop element
                const backdropElement = document.querySelector('.modal-backdrop');
                if (backdropElement) {
                    backdropElement.remove();
                }
            }

            let url = 'https://customtechnologies.biz/dhyana/sendmail.php';
            try {
                const form_data = new FormData();
                form_data.append("user_name", formData.name);
                form_data.append("user_email", formData.email);
                form_data.append("user_org", formData.organization);
                form_data.append("user_cmt", formData.comments);

                const response = await fetch(url, {
                    method: 'POST',
                    body: form_data,
                });

                const result = await response.text();

                if (result === 'Message has been sent') {
                    // Success: Show Thank You modal with success message
                    setModalTitle('Thank You!');
                    setModalBodyText('Thank you for contacting us. We will get back to you shortly.');
                } else {
                    throw new Error('Failed to Send');
                }

            } catch (err) {
                console.error('Error during form submission:', err.message);
                setModalTitle('Error');
                setModalBodyText('There was an error submitting the form. Please try again later.');
            } finally {
                setShowLoading(false); // Hide loading spinner
                const thankYouModalElement = document.getElementById('thankYouModal');
                if (thankYouModalElement) {
                    const thankYouModalInstance = new Modal('#thankYouModal', {
                        backdrop: true
                    }); // Get the modal instance
                    thankYouModalInstance?.show(); // Open Thank You/Error modal
                }
            }
        }
    };

    const handleThankYouModalClose = () => {
        // Clear form data when Thank You modal is closed
        setFormData({
            name: '',
            email: '',
            organization: '',
            comments: ''
        });

        // const modalElement = document.getElementById('thankYouModal');
        // if (modalElement) {
        //     const modalInstance = Modal.getInstance(modalElement); // Get the modal instance
        //     modalInstance?.hide(); // Close the modal

        //     // Manually remove the modal-backdrop element
        //     const backdropElement = document.querySelector('.modal-backdrop');
        //     if (backdropElement) {
        //         backdropElement.remove();

        //     }
        // }

        // setShowThankYouModal(false);

        const modalElement = document.getElementById('thankYouModal');
        if (modalElement) {
            const modalInstance = Modal.getInstance(modalElement); // Get the modal instance
            modalInstance?.hide(); // Close the modal

            // Wait for Bootstrap's modal event to complete its animation, then clean up
            modalElement.addEventListener('hidden.bs.modal', () => {
                const backdropElement = document.querySelector('.modal-backdrop');
                if (backdropElement) {
                    backdropElement.remove(); // Manually remove the modal backdrop
                }
                setShowThankYouModal(false); // Hide the Thank You modal state
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
            }, { once: true });
        }




        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    };

    // useEffect(() => {
    //     if (!showThankYouModal) {
    //         document.body.style.overflow = '';
    //         document.body.style.paddingRight = '';
    //     }

    // }, [showThankYouModal])

    return (
        <>
            {/* Loading Spinner */}
            {showLoading && (
                <div className="loading-spinner load-spin1">
                    <span className="loader"></span>
                    {/* <div>
                    <span className="loader"></span>
                    </div> */}
                    {/* <div className="spinner-border" role="status">
                    <span className="loader"></span>
                        <span className="visually-hidden">Loading...</span>
                    </div> */}
                </div>
            )}

            {/* Main Form Modal */}
            <div className="modal fade font_nun_reg" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 sm_dash font_nun_bold" id="staticBackdropLabel">Connect with us</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {/* Form Fields */}
                            <div className="mb-3">
                                <label htmlFor="nameInput" className="form-label">Name</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                    id="nameInput"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                                {errors.name && <div className="invalid-feedback">Name is required.</div>}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="emailInput" className="form-label">Email address</label>
                                <input
                                    type="email"
                                    className={`form-control ${errors.email || errors.emailInvalid ? 'is-invalid' : ''}`}
                                    id="emailInput"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    aria-describedby="emailHelp"
                                />
                                {errors.email && <div className="invalid-feedback">Email is required.</div>}
                                {errors.emailInvalid && <div className="invalid-feedback">Please enter a valid email address.</div>}
                                <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="organizationInput" className="form-label">Organization</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.organization ? 'is-invalid' : ''}`}
                                    id="organizationInput"
                                    name="organization"
                                    value={formData.organization}
                                    onChange={handleChange}
                                />
                                {errors.organization && <div className="invalid-feedback">Organization is required.</div>}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="commentsInput">Comments</label>
                                <textarea
                                    className={`form-control ${errors.comments ? 'is-invalid' : ''}`}
                                    placeholder="Leave a comment here"
                                    id="commentsInput"
                                    name="comments"
                                    value={formData.comments}
                                    onChange={handleChange}
                                    style={{ height: "5rem" }}
                                ></textarea>
                                {errors.comments && <div className="invalid-feedback">Comments are required.</div>}
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className='d-flex modal-logo-bar' >
                                    <img src="assets/images/CTlogo_black-512.png" alt=""  />
                                    <img src='assets/images/Dhyana_Logo_black-512.png'  className='ms-2' />
                                </div>
                                <div className='d-flex'>
                                    <button type="button" className="btn btn-primary lh-base mt-auto" style={{ background: 'rgb(2, 29, 255)' }} onClick={handleSubmit}>
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            'Submit'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Thank You/Error Modal */}
            <div className={`modal fade ${showThankYouModal ? 'show' : ''}`} style={{ display: showThankYouModal ? 'block' : 'none' }} id="thankYouModal" tabIndex={-1} aria-labelledby="thankYouModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="thankYouModalLabel">{modalTitle}</h1>
                            <button type="button" className="btn-close" aria-label="Close" onClick={handleThankYouModalClose}></button>
                        </div>
                        <div className="modal-body">
                            {modalBodyText}
                        </div>
                        <div className="modal-footer">
                            <div className="d-flex justify-content-between w-100">
                                <div className='d-flex modal-logo-bar' >
                                    <img src="assets/images/CTlogo_black-512.png" alt=""  />
                                    <img src='assets/images/Dhyana_Logo_black-512.png'  className='ms-2' />
                                </div>
                                <div className='d-flex'>
                                    <button type="button" className="btn btn-primary lh-base mt-auto" style={{ background: 'rgb(2, 29, 255)' }} onClick={handleThankYouModalClose}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactUs_ModalComponent;
